import {Injectable} from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';


@Injectable()
export class ErrorMessageProvider {

    constructor(private snackBar: MatSnackBar) {
    }

    show(error){
        if(error.validationErrors){
            let err = error.validationErrors;
            let message = '';

            if(err.denials){
                message = err.denials[0];
            }else{
                for(let i in err){
                    message += err[i];
                    break;
                }
            }

            let label = 'Cerrar';
            let duration = 4500;

            const config = new MatSnackBarConfig();
            config.duration = duration;
            config.extraClasses = ['error-snackbar'];
            //config.extraClasses = [];
            this.snackBar.open(message, label, config);

        }else if(typeof error === 'string'){

            const config = new MatSnackBarConfig();
            config.duration = 4500;
            config.extraClasses = ['error-snackbar'];

            this.snackBar.open(error, 'Cerrar', config);
        }
    }
}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/providers/error.message.provider.ts